module.exports = __webpack_public_path__ + "img/lightblue-bg.dcb5950c.png";